import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-slots-upgraded-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './slots-upgraded.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class SlotsUpgradedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<SlotsUpgradedTemplateData>;
}

export type SlotsUpgradedTemplateData = {
  header: string;
  avatar_url: string;
  title_html: string;
  button_text: string;
  button_link: string;
  footer: string;
};

export const SlotsUpgradedTemplateMocks: SlotsUpgradedTemplateData[] = [
  {
    header: 'Job slots updated',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    title_html:
      '<b>Olivia Novak</b> has just updated the number of available job slots in {Company name} from <b>10</b> to <b>20</b>.',
    button_text: 'Join your team now',
    button_link: 'http://recruitee.com',
    footer: 'You received this email because you’re the account admin.',
  },
];
